import { SR_API_ACTION_MANUAL_ID_VERIFICATION_GET_PENDING_LIST } from 'api/actionTypes';

export default async function getPendingManualIdVerificationList({ state, apiClient }) {
  await apiClient.postWithState({
    action: SR_API_ACTION_MANUAL_ID_VERIFICATION_GET_PENDING_LIST,
    state: state,
    onSuccess(manualIdVerificationList) {
      state.set(['manualIdVerifications', 'list'], manualIdVerificationList);
    },
  });
}
